// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3OKqR","colMaxWidth":"Table_colMaxWidth__2DvUE"};